<template>
  <div class="page-container">
    <div class="general-header" ref="header-container">
      <div class="header-container flex-box justify-content-between">
        <div class="">
          <a href="https://symbium.com">
            <div class="header-logo"></div>
          </a>
        </div>
        <div class="product-link">
          <a class="link active" href="https://symbium.com">
            Products
          </a>
        </div>
      </div>
    </div>
    <div class="message-container">
      <div class="thank-you-message max-1200">{{message}}</div>
    </div>
    <div id="symbium-footer"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: undefined,
    }
  },
  methods: {
    handleScroll() {
      if (this.$refs['header-container']) {
        if (window.scrollY >= 24) {
          this.$refs['header-container'].classList.add('fixed-header')
        } else {
          this.$refs['header-container'].classList.remove('fixed-header')
        }
      }
    }
  },
  mounted() {
    this.message = this.$route.query.message;
    window.scrollTo(0,0);
    window.addEventListener('scroll', this.handleScroll);

    // create footer
    this.$nextTick(() => {
      const prefixLink = process.env.VUE_APP_HOME_PAGE
      const footerScript = document.createElement('script')
      footerScript.text = `
        new Footer("symbium-footer", "${prefixLink}");`
      document.head.appendChild(footerScript)
    })
  }
}
</script>

<style lang="scss">
.footer-subscribe-email-input {
  border: none !important;
  border-bottom: 1px solid #fff !important;
  height: unset;
  font-size: 14px !important;
  line-height: 16px !important;
}
</style>

<style scoped lang="scss">
.header-container {
  padding: 24px 120px;
  transition: background-color 0.3s ease, top 0.3s ease-in-out;
}

.fixed-header {
  background-color: white;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
}

.thank-you-message {
  padding: 186px 0 240px 0;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 96px;
  line-height: 104px;
  letter-spacing: -2.88px;
}

.message-container, .symbian-container {
  padding: 80px 120px;
}

@media only screen and (max-width: 1200px) {
  .page-container .thank-you-message {
    font-size: 64px;
    line-height: 80px;
  }
}

@media only screen and (min-width: 1360px) {
    .symbian-container,.social-area, .header-container {
       padding-left: calc(50% - 600px);
       padding-right: calc(50% - 600px);
    }
}

@media only screen and (max-width: 600px) {
  .page-container .thank-you-message {
    font-size: 48px;
    line-height: 60px;
  }
  
  .header-container, .message-container, .symbian-container {
    padding: 24px;
  }

  .page-container .thank-you-message {
    font-size: 64px;
    line-height: 80px;
    padding: 116px 0 80px 0;
    font-size: 40px;
    line-height: 48px;
  }

  .fixed-header {
    top: -68px;
  }
}

.display-block {
  display: block;
}
</style>
